/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPermissionFromJSON, ApiPermissionToJSON, } from './ApiPermission';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiUserFromJSON(json) {
    return ApiUserFromJSONTyped(json, false);
}
export function ApiUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'authId': !exists(json, 'authId') ? undefined : json['authId'],
        'createDatetime': !exists(json, 'createDatetime') ? undefined : (new Date(json['createDatetime'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : json['jobTitle'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(ApiPermissionFromJSON)),
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'updatedDatetime': !exists(json, 'updatedDatetime') ? undefined : (new Date(json['updatedDatetime'])),
        'verifiedDatetime': !exists(json, 'verifiedDatetime') ? undefined : (new Date(json['verifiedDatetime'])),
    };
}
export function ApiUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'authId': value.authId,
        'createDatetime': value.createDatetime === undefined ? undefined : (value.createDatetime.toISOString()),
        'email': value.email,
        'id': value.id,
        'ip': value.ip,
        'jobTitle': value.jobTitle,
        'name': value.name,
        'password': value.password,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(ApiPermissionToJSON)),
        'status': ApiStatusToJSON(value.status),
        'updatedDatetime': value.updatedDatetime === undefined ? undefined : (value.updatedDatetime.toISOString()),
        'verifiedDatetime': value.verifiedDatetime === undefined ? undefined : (value.verifiedDatetime.toISOString()),
    };
}
